module.exports = __webpack_public_path__ + "img/Alan-Fernandes-Design.14008a98.jpg";